/**
 * Session-scoped Add Client draft for auth-expiry recovery.
 * Does not store SSNs, passwords, or tokens.
 */

const KEY_PREFIX = 'funding-hq:add-client-draft';

const SENSITIVE_FORM_KEYS = [
  'ssn',
  'ein',
  'applicationPasswordCreated',
  'application_password_created',
  'password',
  'token',
  'access_token',
  'refresh_token',
];

export function addClientDraftStorageKey(scopeId) {
  return `${KEY_PREFIX}:${scopeId || 'unknown'}`;
}

export function sanitizeAddClientDraftForm(form = {}) {
  const next = { ...form };
  SENSITIVE_FORM_KEYS.forEach((key) => {
    if (key in next) delete next[key];
  });
  return next;
}

export function saveAddClientSessionDraft(scopeId, form) {
  if (typeof window === 'undefined' || !scopeId) return null;
  const payload = {
    scopeId,
    form: sanitizeAddClientDraftForm(form),
    requiresSensitiveReentry: Boolean(
      form?.ssn?.trim()
      || form?.ein?.trim()
      || form?.applicationPasswordCreated?.trim()
    ),
    savedAt: new Date().toISOString(),
  };
  try {
    window.sessionStorage.setItem(addClientDraftStorageKey(scopeId), JSON.stringify(payload));
    return payload;
  } catch {
    return null;
  }
}

export function loadAddClientSessionDraft(scopeId) {
  if (typeof window === 'undefined' || !scopeId) return null;
  try {
    const raw = window.sessionStorage.getItem(addClientDraftStorageKey(scopeId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      ...parsed,
      form: sanitizeAddClientDraftForm(parsed.form || {}),
    };
  } catch {
    return null;
  }
}

export function clearAddClientSessionDraft(scopeId) {
  if (typeof window === 'undefined' || !scopeId) return;
  try {
    window.sessionStorage.removeItem(addClientDraftStorageKey(scopeId));
  } catch {
    // ignore
  }
}
